import { render } from "./AddMatch.vue?vue&type=template&id=734aa898"
import script from "./AddMatch.vue?vue&type=script&lang=js"
export * from "./AddMatch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__